module.exports = __webpack_public_path__ + "img/icon-edit.573d8960.svg";